import { Navigate } from "react-router-dom";

const RedirectYourBananasPage = () => <Navigate to="/your-bananas" replace />;

export default RedirectYourBananasPage;
